<template>

  <div>
    <md-card class="md-layout-item md-size-100">
      <md-card-header>
        <md-button class="md-icon-button" @click="print()" style="float:right;">
          <md-icon>print</md-icon>
        </md-button>
        <div class="md-title">Scarico</div>
      </md-card-header>
      <md-card-content class="barcodes">
        <div class="md-layout nota">
          <div><strong>Nota di Scarico</strong> {{row.deliveryNote}}</div>
        </div>
        <div class="md-layout sap" v-for="sap in row.details">
          <div class="md-layout-item md-size-100 material"><strong>SAP</strong> {{sap.materialNumber}} - {{sap.description}}</div>
          <template v-for="(pallet, index) in sap.ssccNumber">
            <!-- p style="page-break-before: always" v-if="index>1 && index%7===0">&nbsp;</p -->
            <div class="md-layout-item md-size-25 pallet">
              <img :src="'/data/barcode/' + pallet.pallet">
              <span>{{pallet.pallet.padStart(20,'0')}}</span>
            </div>
          </template>
        </div>
      </md-card-content>
      <md-card-actions>
        <md-button type="button" class="md-primary" to="/scarico">Indietro</md-button>
      </md-card-actions>
    </md-card>
  </div>

</template>
<script>

  import print from 'print-js'

  export default {
    name: 'ViewBarcode',
    data: function() {
      return {
        row: {}
      }
    },
    mounted() {
      if (this.$route.params.id !== undefined) {
        let params = {
          action: 'load',
          id: this.$route.params.id
        }
        let loading = this.$loading.show()
        this.$http
          .post('/data/scarico', params, { headers: { Authorization: 'Bearer ' + this.$cookie.get('token') } })
          .then(response => {
            loading.hide()
            if (response.data.done) {
              this.edit = false
              this.row = response.data.data
            } else {
              this.$fire({
                html: 'Errore di sistema: ' + response.data.message,
                type: 'error'
              }).then(r => {
                if (response.data.bu != '') this.$router.push(response.data.bu)
              })
            }
          })
      }
    },
    methods: {
      print() {
        window.print();
        //document.getElementById('print-container').innerHTML = document.querySelector('.barcodes').innerHTML
        //printJS({ printable: 'print-container', type: 'html', documentTitle: '', header: '' })
      }
    }
  }

</script>
<style lang="css" scoped>
  .barcodes {
    font-size: 16px;
  }
  .sap {
    margin-bottom: 40px;
  }
  .pallet {
    display: flex;
    flex-direction: column;
    margin: 10px 0;
    align-items: center;
  }
</style>
<style lang="css">
@media print {
  .md-app-content {height:100%!important;}
  .nota {
    width: 100%;
    display: block;
    font-size: 32px;
    text-align: center;
    line-height: 40px;
    margin: 10px 0;
  }
  .material {
    width: 100%;
    display: block;
    font-size: 24px;
    text-align: center;
    margin:10px 0 10px 0;
  }
  .pallet {
    /*width: 50%;
    display: block;*/
    text-align: center;
    /*margin: 0 15px;*/
    padding: 0 15px;
  }
  .pallet > span {font-size:10px;}
  .md-button,.md-title {display: none!important;}
  .md-app.md-reveal .md-app-toolbar {
    position: relative;
    display: none;
  }
  .md-app-scroller {margin-top:0!important;}
  .md-toolbar.md-app-toolbar {display: none!important;}
  .md-reveal .md-reveal-active{
    transform: none;
    transition: none;
    transition-property: none;
    will-change: initial;
    display: none;
  }
  .md-card{border:0!important;box-shadow:none!important;}
  .nota {text-align:center;display: inline-block!important;}
}
</style>



// WEBPACK FOOTER //
// src/components/ViewBarcode.vue